export default "__VITE_ASSET__AJdxNBON__"